module.exports = __webpack_public_path__ + "img/laptop.3c4423b3.png";